import React, { useState, useEffect, useCallback } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Button, Card, Spinner } from "react-bootstrap";
import { useLoading } from "../contexts/LoadingContext";
import Navbar from "../components/Navbar";
import Loader from "../components/loader";
import Footer from "../components/Footer";
import Swal from "sweetalert2";
import { ref, onValue } from "firebase/database";
import { database } from "../firebase/firebaseConfig";
import "./DoctorProfile.css"; // Custom CSS for additional styling

const DoctorProfile = () => {
  const [doctorProfile, setDoctorProfile] = useState(null);
  const [showFullAbout, setShowFullAbout] = useState(false);
  const { isLoading, setIsLoading } = useLoading();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const session = JSON.parse(sessionStorage.getItem("user"));
  const [realtimeStatus, setRealtimeStatus] = useState(null);

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  useEffect(() => {
    const fetchDoctorProfile = async () => {
      setIsLoading(true);
      try {        const response = await fetch(
          `${API_BASE_URL}/specialist/view?user_id=${id}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch doctor profile");
        }
        const data = await response.json();
        if (data.statusCode === 1 && data.payLoad) {
          setDoctorProfile(data.payLoad);
          const emailKey = data.payLoad.Email.replace(/\./g, "");
          const statusRef = ref(database, `Doctors/${emailKey}/status`);
          const unsubscribe = onValue(statusRef, (snapshot) => {
            setRealtimeStatus(snapshot.val());
          });
          return () => unsubscribe();
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Error fetching doctor profile:", error);
        Swal.fire("Error!", "Failed to load doctor profile.", "error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDoctorProfile();
  }, [id, setIsLoading]);

  const handleCallNow = async () => {
    if (!doctorProfile?.Email) {
      Swal.fire("Error", "Doctor email not found.", "error");
      return;
    }
    const emailKey = doctorProfile.Email.replace(/\./g, "");
    const statusRef = ref(database, `Doctors/${emailKey}/status`);
    let latestStatus = realtimeStatus;
    await new Promise((resolve) => {
      onValue(
        statusRef,
        (snapshot) => {
          latestStatus = snapshot.val();
          resolve();
        },
        { onlyOnce: true }
      );
    });

    if (latestStatus !== "online") {
      Swal.fire({
        icon: "info",
        title: "Please wait",
        text: "Please wait for the doctor to come online.",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return;
    }

    if (!session?.payLoad?.access_token) {
      Swal.fire({
        icon: "info",
        title: "Login",
        text: "Please login first",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      }).then(() => {
        navigate(`/login/doctor-profile`);
        return;
      });
    } else if (
      !session?.payLoad.user.userPackages ||
      session.payLoad.user.userPackages.length === 0
    ) {
      navigate("/packages");
    } else {
      var fromCall = "doctorProfile";
      navigate(`/video-call`, {
        state: {
          appointment: 1,
          email: doctorProfile.Email,
          doctorId: id,
          fromCall: fromCall,
        },
      });
    }
  };

  const toggleShowFullAbout = () => {
    setShowFullAbout((prev) => !prev);
  };
  return (
    <>
      <Navbar isLoggedIn={isLoggedIn} onLogout={handleLogout} />
      {isLoading ? (
        <Container fluid className="mt-3 mb-4">
          <Loader type="doctorProfile" />
        </Container>
      ) : !doctorProfile ? (
        <Container>
          <h2>No doctor profile found.</h2>
        </Container>
      ) : (
        <Container fluid className="mt-3 mb-4">
          <Row className="justify-content-center">
            <Col md={8} lg={7}>
              <Card className="shadow-lg border-0 rounded">
                <Card.Header className="text-center bg-primary text-white">
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <Col md={4} lg={3} className="text-center mb-4 mb-md-0">
                      <img
                        src={doctorProfile.ImgLink}
                        alt="Doctor Profile"
                        className="img-fluid rounded-circle border border-light"
                        style={{ width: "150px", height: "150px" }}
                      />
                    </Col>
                  </div>
                  <Row>
                    <h2 className="mb-0 text-white">
                      {doctorProfile.FirstName}
                    </h2>
                  </Row>
                  <Row>
                    <Col className="text-center d-flex flex-row align-items-center justify-content-center">
                      <div>
                        {doctorProfile.AverageRating != null &&
                          doctorProfile.AverageRating > 0 && (
                            <span className="badge bg-warning text-dark">
                              {doctorProfile.AverageRating.toFixed(1)}
                            </span>
                          )}
                        {doctorProfile.RatingCount != null &&
                          doctorProfile.RatingCount > 0 && (
                            <span className="text-white">
                              {" "}
                              ({doctorProfile.RatingCount} reviews)
                            </span>
                          )}
                      </div>
                      {doctorProfile.DoctorType !== "Specialist" && (
                        <span
                          className={`badge ${
                            realtimeStatus === "online"
                              ? "bg-success"
                              : realtimeStatus === "busy"
                              ? "bg-warning"
                              : "bg-secondary"
                          }`}
                        >
                          {realtimeStatus
                            ? realtimeStatus.toUpperCase()
                            : "OFFLINE"}
                        </span>
                      )}
                    </Col>
                  </Row>

                  <Row className="mt-3 justify-content-center">
                    {doctorProfile.DoctorType !== "Specialist" && (
                      <Col xs={6} md={4} lg={3} className="text-center ">
                        <Button
                          variant="success"
                          className="call-button"
                          onClick={handleCallNow}
                          style={{
                            fontSize: "1rem",
                            width: "100%",
                            padding: "10px 20px",
                            borderRadius: "15px",
                          }}
                        >
                          Call Now
                        </Button>
                      </Col>
                    )}
                  </Row>
                </Card.Header>
                <Card.Body>
                  <Card.Text className="mb-4" style={{ fontSize: "0.875rem" }}>
                    <strong>Experience:</strong> {doctorProfile.Experience}
                    <br />
                    <strong>Duty Time:</strong> {doctorProfile.DoctorDutyTime}
                    <br />
                    <strong>Qualifications:</strong>{" "}
                    {doctorProfile.Allqualifications}
                    <br />
                    <strong>About:</strong>
                    <span
                      className={`justify-text ${
                        showFullAbout ? "" : "line-clamp"
                      }`}
                    >
                      {doctorProfile.DetailedInformation}
                    </span>
                    {!showFullAbout && (
                      <Button
                        variant="link"
                        onClick={toggleShowFullAbout}
                        style={{ fontSize: "0.875rem" }}
                      >
                        Show more
                      </Button>
                    )}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
      <Footer />
    </>
  );
};

export default DoctorProfile;
